var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLeftIconRecall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1479 55.6907L55.6794 11.1634C58.3342 8.50708 60.4862 5.40224 62.0406 2L20.0659 2C15.2746 2 10.6795 3.90369 7.2915 7.29242C3.90346 10.6812 2 15.2774 2 20.07L2 62.04C5.3957 60.488 8.49513 58.34 11.1479 55.6907Z",
    fill: "#9467DB",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftIconRecall);
export default __webpack_public_path__ + "static/media/BottomLeftIconRecall.cc0010b0a4a526d702088ed73625fade.svg";
export { ForwardRef as ReactComponent };